import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Navbar,
  Nav,
  NavItem,
  Button,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Collapse,
  UncontrolledButtonDropdown,
  Dropdown,
  Badge
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faChevronDown,
  faBell,
  faComments,
  faVideo
} from "@fortawesome/free-solid-svg-icons";
import "./header.css";
import "./notifications.css";
import { connect } from "react-redux";
import * as UserProvider from "../../providers/userProvider";
import { getChats } from "../../providers/chatProvider";
import VideoNotifications from "./videoNotifications";
import { getGroups } from "../../providers/categoryProvider";
import { removeVideochat } from "../../actions";

class MenuHeader extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
    this.state = {
      collapse: false,
      dropdownOpen: false,
      logoutRedirect: false
    };
    this.shouldSubscribe = true;
    this.unsubscribe = () => {};
    this.unsubscribeFromVideos = () => {};
    this.unsubscribeFromChats = () => {};
  }

  toggleNav = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  toggleCat = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  logout = () => {
    this.props.doLogout(this.props.userId);
  };

  async componentDidUpdate() {
    /* if(this.shouldSubscribe && this.props.auth) {
            if(!this.props.auth.uid) return;
            //this.unsubscribe = this.props.doGetRequestAnswer(this.props.auth.uid);
            this.unsubscribeFromVideos = this.props.doGetVideos(this.props.auth.uid);
            this.unsubscribeFromChats = this.props.doGetChats(this.props.auth.uid);
            //console.log('subscribing');
            this.shouldSubscribe = false;
        } */
  }

  componentDidMount() {
    //this.props.doGetGroups();
  }

  componentWillUnmount() {
    //console.log('unsubscribing');
    //this.unsubscribe();
    this.unsubscribeFromVideos();
    this.unsubscribeFromChats();
  }

  renderBadge() {
    let number = 0;
    if (this.props.consults)
      number += Object.values(this.props.consults).filter(value => value)
        .length;
    number += this.props.requestAnswers.size;
    if (number === 0) return null;
    return (
      <Badge pill className="notification-badge">
        {number}
      </Badge>
    );
  }

  renderVideoBadge() {
    //console.log(this.props.videos);
    //console.log(this.props.videos.length);
    if (this.props.videos.length <= 0) return null;

    return (
      <Badge pill className="notification-badge">
        {this.props.videos.length}
      </Badge>
    );
  }

  render() {

    /* const messagesNotifications = this.props.chats.reduce((acc, current) => {            
            if(current.data.professional === this.props.auth.uid & current.data.status === "requested")
                return acc + 1;
            return acc;
        }, 0) */

    return (
      <div className="menu-header-container">
        <Navbar expand="md" className="align-items-center">
          <Collapse isOpen={this.state.collapse} navbar>
            <Nav className="align-items-center" navbar>
              <NavItem>
                <Link className="nav-link" to={"/"}>
                  Início
                </Link>
              </NavItem>
              <UncontrolledButtonDropdown
                nav
                inNavbar
                tag="div"
                className="hide-if-mobile"
              >
                <DropdownToggle nav caret>
                  Especialidades
                </DropdownToggle>
                <DropdownMenu>
                  {this.props.groups.map(group => {
                    return (
                      <React.Fragment key={group._id}>
                        <DropdownItem header>{group.name}</DropdownItem>
                        {group.categories.map(item => {
                          /* if(item.category.parentGroupId !== group.ref.path) 
                                                                return null; */
                          return (
                            <Link
                              key={item._id}
                              to={`/categoria/${item._id}/profissionais`}
                            >
                              <DropdownItem>{item.name}</DropdownItem>
                            </Link>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}

                  {/* this.props.categories.map(item => (
                                                <Link key={item.ref.id} to={`/categoria/${item.ref.id}/profissionais`}>
                                                    <DropdownItem>{item.category.name}</DropdownItem>
                                                </Link>
                                            )) */}
                  {/* <UncontrolledButtonDropdown
                                            nav
                                            inNavbar
                                            direction='right'
                                            className='hide-drop-if-tablet'
                                            >
                                                <DropdownToggle 
                                                nav
                                                caret
                                                className='subdrop-title'
                                                >
                                                    Direito
                                                </DropdownToggle>
                                                <DropdownMenu className='subdrop'>
                                                <DropdownItem disabled 
                                                        className='color-item item-title border-bottom'>
                                                            Direito
                                                        </DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Direito Constitucional</DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Direito Administrativo</DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Direito Penal</DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Direito Tributário</DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Direito Internacional Público</DropdownItem>
                                                        <div className='main-consult-container'>
                                                            <DropdownItem header className='main-consult-header'>Principais Consultores</DropdownItem>
                                                            <div className='d-inline-flex mt-3 bd-highlight'>
                                                                <DropdownItem className='subdrop-item-consult mr-4'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcia.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Marcia Araújo</p>
                                                                </DropdownItem>
                                                                <DropdownItem className='subdrop-item-consult'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcos.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Roberto Assunção</p>
                                                                </DropdownItem>
                                                            </div>
                                                            <div className='d-inline-flex mt-3 bd-highlight'>
                                                                <DropdownItem className='subdrop-item-consult subdrop-second-item-consult mr-4'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcia.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Marcia Araújo</p>
                                                                </DropdownItem>
                                                                <DropdownItem className='subdrop-item-consult subdrop-second-item-consult'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcos.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Roberto Assunção</p>
                                                                </DropdownItem>
                                                            </div>
                                                        </div>
                                                    </DropdownMenu>
                                            </UncontrolledButtonDropdown>*/}
                  {/* <UncontrolledButtonDropdown
                                            nav
                                            inNavbar
                                            direction='right'
                                            className='hide-drop-if-tablet'
                                            >
                                                <DropdownToggle 
                                                nav
                                                caret
                                                className='subdrop-title'
                                                >
                                                    Empresarial
                                                </DropdownToggle>
                                                    <DropdownMenu className='subdrop'>
                                                        <DropdownItem disabled 
                                                        className='color-item item-title border-bottom'>
                                                            Empresarial
                                                        </DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Pequenas Empresas</DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Médias Empresas</DropdownItem>
                                                        <DropdownItem className='color-item regular-item'>Grandes</DropdownItem>
                                                        <div className='main-consult-container'>
                                                            <DropdownItem header className='main-consult-header'>Principais Consultores</DropdownItem>
                                                            <div className='d-inline-flex mt-3 bd-highlight'>
                                                                <DropdownItem className='subdrop-item-consult mr-4'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcia.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Marcia Araújo</p>
                                                                </DropdownItem>
                                                                <DropdownItem className='subdrop-item-consult'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcos.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Roberto Assunção</p>
                                                                </DropdownItem>
                                                            </div>
                                                            <div className='d-inline-flex mt-3 bd-highlight'>
                                                                <DropdownItem className='subdrop-item-consult subdrop-second-item-consult mr-4'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcia.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Marcia Araújo</p>
                                                                </DropdownItem>
                                                                <DropdownItem className='subdrop-item-consult subdrop-second-item-consult'>
                                                                    <img className='subdrop-img' src={require('../../imagens/profissionais/marcos.jpg')} />
                                                                    <p className='subdrop-text-name-consult'>Roberto Assunção</p>
                                                                </DropdownItem>
                                                            </div>
                                                        </div>
                                                    </DropdownMenu>
                                            </UncontrolledButtonDropdown> */}
                  {/* <DropdownItem className='show-drop-if-tablet'>Direito</DropdownItem>
                                            <DropdownItem className='show-drop-if-tablet'>Empresarial</DropdownItem>
                                            <DropdownItem>Contabilidade</DropdownItem>
                                            <DropdownItem>Guia de estudos</DropdownItem>
                                            <DropdownItem>Psicologia</DropdownItem>
                                            <DropdownItem>Nutrição</DropdownItem>
                                            <DropdownItem>Fotografia</DropdownItem>
                                            <DropdownItem>Dentista</DropdownItem>
                                            <DropdownItem>Visto para o exterior</DropdownItem> */}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
              <NavItem>
                <Link className="nav-link" to={"/como-funciona"}>
                  Como funciona
                </Link>
              </NavItem>
            </Nav>
            <Nav className="ml-auto align-items-center" navbar>
              {this.props.authUser ? null : (
                <NavItem>
                  <Link className="nav-link" to={"/signup"}>
                    Cadastrar
                  </Link>
                </NavItem>
              )}
              {this.props.authUser ? (
                <div>
                  <div className="d-flex align-items-center hide-if-mobile-flex">
                    {/* <NavItem>
                                                <UncontrolledButtonDropdown>
                                                    <span
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        className='nav-link'
                                                        style={{position:'relative'}}
                                                    >
                                                        <FontAwesomeIcon 
                                                            icon={faBell} 
                                                            transform="down-1 grow-3"
                                                            color="white" />
                                                        {this.renderBadge()}
                                                    </span>
                                                    <DropdownMenu className="dropdown-notifications">
                                                        <NotificationList 
                                                            consults={this.props.consults} 
                                                            answers={this.props.requestAnswers}
                                                        />
                                                    </DropdownMenu>
                                                </UncontrolledButtonDropdown>
                                            </NavItem> */}
                    <NavItem>
                      <UncontrolledButtonDropdown>
                        <span
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          className="nav-link"
                          style={{ position: "relative" }}
                        >
                          <FontAwesomeIcon
                            icon={faVideo}
                            transform="down-1 grow-3"
                            color="white"
                          />
                          {this.renderVideoBadge()}
                        </span>
                        <DropdownMenu className="dropdown-notifications">
                          {/* <NotificationList 
                                                            consults={this.props.consults} 
                                                            answers={this.props.requestAnswers}
                                                        /> */}
                          <VideoNotifications
                            videos={this.props.videos}
                            token={this.props.token}
                            removeNotification={
                              this.props.doRemoveVideoNotification
                            }
                          />
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    </NavItem>
                    <NavItem className="ml-2">
                      <Link to="/chat">
                        <FontAwesomeIcon
                          icon={faComments}
                          transform="down-1 grow-3"
                          color="white"
                        />
                        <Badge pill className="notification-badge">
                          {this.props.chatNotifications
                            ? this.props.chatNotifications
                            : null}
                        </Badge>
                      </Link>
                    </NavItem>
                    <NavItem className="ml-2">
                      <Dropdown
                        nav
                        inNavbar
                        tag="div"
                        isOpen={this.state.dropdownOpen}
                        toggle={this.toggleCat}
                      >
                        <span
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded={this.state.dropdownOpen}
                          className="nav-link"
                        >
                          <FontAwesomeIcon
                            icon={faUserCircle}
                            transform="down-1 grow-3"
                            color="white"
                            className="mr-2"
                          />
                          {this.props.first_name}
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            transform="shrink-4 down-2"
                            color="white"
                          />
                        </span>
                        <DropdownMenu className="profile-drop-menu">
                          <div className="main-consult-container profile-drop-menu-card">
                            <FontAwesomeIcon
                              icon={faUserCircle}
                              transform="grow-80 down-50"
                              color="#267e96"
                            />
                            <div className="profile-drop-menu-card-text mb-2">
                              <div style={{ fontSize: 20, fontWeight: 350 }}>
                                Olá, {this.props.first_name}
                              </div>
                              {/* <div>{this.props.credits} créditos</div> */}
                            </div>
                          </div>

                          <div>
                            <Link
                              onClick={this.toggleCat}
                              to={
                                this.props.isProfessional
                                  ? "/profile-professional"
                                  : "/profile"
                              }
                              className="profile-drop-item-link"
                            >
                              <DropdownItem className="profile-drop-item">
                                Sua conta
                              </DropdownItem>
                            </Link>
                            {/* <DropdownItem
                                                                className='profile-drop-item'>
                                                                    Extrato da conta
                                                                </DropdownItem> */}
                            {/* <Link
                              onClick={this.toggleCat}
                              to="/credit/checkout"
                              className="profile-drop-item-link"
                            >
                              <DropdownItem className="profile-drop-item">
                                Comprar créditos
                              </DropdownItem>
                            </Link> */}
                            {/* <Link to='/consults' className='profile-drop-item-link'>
                                                                    <DropdownItem className='profile-drop-item'>
                                                                        Ver consultorias
                                                                    </DropdownItem>
                                                                </Link> */}
                            {/* <DropdownItem
                                                                className='profile-drop-item'>
                                                                    Configurar opções de saque
                                                                </DropdownItem> */}
                            <Link
                              onClick={this.toggleCat}
                              to="/"
                              className="profile-drop-item-link"
                            >
                              <DropdownItem
                                className="profile-drop-item"
                                onClick={this.logout}
                              >
                                Sair
                              </DropdownItem>
                            </Link>
                          </div>
                        </DropdownMenu>
                      </Dropdown>
                    </NavItem>
                  </div>
                  <div className="show-if-mobile">
                    <NavItem>
                      <Link
                        className="nav-link btn-login"
                        to={
                          this.props.isProfessional
                            ? "/profile-professional"
                            : "/profile"
                        }
                      >
                        {this.props.first_name}
                      </Link>
                    </NavItem>
                  </div>
                </div>
              ) : (
                <NavItem>
                  <Link className="nav-link" to={"/login"}>
                    <Button outline className="btn-login">
                      Entrar
                    </Button>
                  </Link>
                </NavItem>
              )}
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    doLogout: userId => dispatch(UserProvider.signOut(userId)),
    doGetChats: uid => dispatch(getChats(uid)),
    doGetGroups: () => dispatch(getGroups()),
    doRemoveVideoNotification: consultId => dispatch(removeVideochat(consultId))
  };
};
const mapStateToProps = state => {
  return {
    authUser: state.user.userInfo.token,
    userId: state.user.userInfo._id,
    first_name: state.user.userInfo.firstName,
    credits: state.user.userInfo.credits,
    token: state.user.userInfo.token,
    isProfessional: state.user.userInfo.isProfessional,
    requestAnswers: state.consults.answers,
    chats: state.chats.list,
    videos: state.chats.videoList,
    groups: state.category.groups,
    chatNotifications: state.chats.notifications
  };
};
//export default connect(mapStateToProps, mapDispatchToProps)(MenuHeader)

export default connect(mapStateToProps, mapDispatchToProps)(MenuHeader);
